// si on veut taper sur la preprod
const { local, pp } = window || {};

export const URL_API = process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : local
        ? 'http://localhost:81'
        : pp
            ? 'https://planning.jvs-mairistem.dev'
            : 'https://planning-gds.jvsonline.fr';
